import React from "react";
import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";
import Isotipo from "@/components/Isotipo";
import { WORLDS } from "./data";

const mont = { fontFamily: "Montserrat, sans-serif" };

// Entry choice between the two sides of the company.
const MockupGateway = ({ theme, onEnter }) => {
  const panels = [
    { ...WORLDS[0], cta: "Entrar al estudio" },
    { ...WORLDS[1], cta: "Entrar a la agencia" },
  ];

  return (
    <motion.div
      data-testid="mockup-gateway"
      className="fixed inset-0 z-[110] flex flex-col md:flex-row"
      style={{ backgroundColor: theme.bg }}
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0, transition: { duration: 0.5 } }}
      transition={{ duration: 0.6 }}
    >
      {panels.map((p, i) => (
        <motion.button
          key={p.id}
          data-testid={`gateway-${p.id}`}
          onClick={onEnter}
          className="group relative flex-1 overflow-hidden flex items-end"
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7, delay: 0.2 + i * 0.12, ease: [0.22, 1, 0.36, 1] }}
        >
          <img
            src={p.image}
            alt={p.label}
            className="absolute inset-0 w-full h-full object-cover transition-transform duration-[1200ms] group-hover:scale-105"
            style={{ filter: "grayscale(0.25) brightness(0.55)" }}
          />
          <div className="absolute inset-0" style={{ background: "linear-gradient(to top, rgba(10,10,16,0.85), rgba(10,10,16,0.2))" }} />
          <div className="relative p-8 md:p-12 text-left w-full">
            <p className="text-[11px] uppercase tracking-[0.3em] mb-3" style={{ ...mont, color: theme.accent }}>{p.label}</p>
            <h2 className="text-2xl md:text-4xl font-bold tracking-tight text-white max-w-sm" style={mont}>{p.line}</h2>
            <span className="mt-6 inline-flex items-center gap-2 text-xs font-bold uppercase tracking-[0.16em] text-white/80 transition-colors group-hover:text-white" style={mont}>
              {p.cta} <ArrowRight size={15} />
            </span>
          </div>
        </motion.button>
      ))}

      {/* Center brand + hint */}
      <motion.div
        className="pointer-events-none absolute inset-0 flex flex-col items-center justify-center"
        initial={{ opacity: 0, scale: 0.9 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ duration: 0.8, delay: 0.1 }}
      >
        <div className="flex items-center gap-2.5 rounded-full px-5 py-2.5 backdrop-blur-md" style={{ backgroundColor: "rgba(10,10,16,0.55)", border: "1px solid rgba(255,255,255,0.15)" }}>
          <Isotipo className="w-5 h-5" fill={theme.accent} />
          <span className="text-sm font-extrabold tracking-tight text-white" style={mont}>GRABARTE</span>
        </div>
        <p className="mt-4 text-[10px] uppercase tracking-[0.3em] text-white/60" style={mont}>Elige tu visión</p>
      </motion.div>
    </motion.div>
  );
};

export default MockupGateway;
